import { useState, useEffect } from "react";
import { List, X } from "@phosphor-icons/react";

const links = [
  { label: "About", href: "#why" },
  { label: "The Method", href: "#method" },
  { label: "Programs", href: "#offers" },
  { label: "Community", href: "#community" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scroll = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 w-full z-50 transition-all duration-500 border-b ${
        scrolled
          ? 'bg-[#050505]/90 backdrop-blur-xl border-white/10 shadow-lg shadow-black/20'
          : 'bg-transparent border-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between h-16">
        <a href="/" data-testid="nav-logo" className="font-heading text-2xl font-black tracking-tighter text-[#F2EFE9]">
          3<span className="text-[#D4AF37]">SM</span>
        </a>
        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={() => scroll(l.href)}
              className="text-sm text-[#8C8C8C] hover:text-[#D4AF37] transition-colors tracking-wide font-body relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-[#D4AF37] transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
        </div>
        <button data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} className="md:hidden text-[#F2EFE9]">
          {open ? <X size={24} /> : <List size={24} />}
        </button>
      </div>
      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden bg-[#050505]/95 backdrop-blur-xl border-t border-white/10 px-6 py-4 space-y-4">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              onClick={() => scroll(l.href)}
              className="block w-full text-left text-[#8C8C8C] hover:text-[#D4AF37] transition-colors text-sm tracking-wide font-body"
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}
